module.exports = __webpack_public_path__ + "img/input_3.3f937dcf.png";